<template>
  <div ref="container">
    <BlockForm
      v-bind="$props"
      :existing-number="cachedNumber"
      @submit="blockNumberSubmit"
      @cacheFormData="cacheFormData"
      @closeForm="$emit('closeForm')"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import callLogActionFormsMixin from '../callLogActionFormsMixin';
import BlockForm from './BlockForm';


export default Vue.extend({
  name: 'BlockNumberForm',
  components: {
    BlockForm,
  },
  mixins: [callLogActionFormsMixin],
  props: {
    phoneNumber: {
      type: String,
      default: ''
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      }
    },
    campaignId: {
      type: String,
      default: ''
    },
    cachedNumber: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  methods: {
    cacheFormData(number) {
      this.$emit('cacheFormData', number);
    },

    blockNumberSubmit(number) {
      this.$emit('blockNumberSubmit', number);
    },
  },
  
});
</script>

<style lang="scss" scoped>

</style>